var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBackIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 18.252H1V1h7.188l2.876 2.875h8.626v14.377h-5.751",
  stroke: "#662D91",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.345 21.846V11.064m0 0L8.188 13.46h4.313l-2.156-2.396Z",
  stroke: "#662D91",
  strokeWidth: 2
})));
export { SvgBackIcon as ReactComponent };
export default __webpack_public_path__ + "2fb76ae80a60df8a90ef3501b9e693c4.svg";